<script setup>
import { BrainIcon, ChevronDownIcon } from "@lucide/vue";
import { Collapsible, CollapsibleTrigger } from "@/components/ui/collapsible";
import { cn } from "@/lib/utils";
import { useChainOfThought } from "./context";

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const { isOpen, setIsOpen } = useChainOfThought();
</script>

<template>
  <Collapsible :open="isOpen" @update:open="setIsOpen">
    <CollapsibleTrigger
      :class="
        cn(
          'flex w-full items-center gap-2 text-muted-foreground text-sm transition-colors hover:text-foreground',
          props.class,
        )
      "
      v-bind="$attrs"
    >
      <BrainIcon class="size-4" />
      <span class="flex-1 text-left">
        <slot>Chain of Thought</slot>
      </span>
      <ChevronDownIcon
        :class="
          cn('size-4 transition-transform', isOpen ? 'rotate-180' : 'rotate-0')
        "
      />
    </CollapsibleTrigger>
  </Collapsible>
</template>
